// extracted by mini-css-extract-plugin
export var displayName = "home-old-module--displayName--5a454";
export var doc = "home-old-module--doc--5fc85";
export var document = "home-old-module--document--6ee62";
export var documents = "home-old-module--documents--81a8f";
export var docx = "home-old-module--docx--81458";
export var expandBoxHeader = "home-old-module--expandBoxHeader--26161";
export var fileName = "home-old-module--fileName--cd0a3";
export var guide = "home-old-module--guide--acdd5";
export var header = "home-old-module--header--1d93e";
export var image = "home-old-module--image--d12f9";
export var main = "home-old-module--main--479bf";
export var pdf = "home-old-module--pdf--85241";
export var ppt = "home-old-module--ppt--c0fc4";
export var pptx = "home-old-module--pptx--7297d";
export var quickDownload = "home-old-module--quickDownload--18b95";
export var text = "home-old-module--text--7d2f6";